import { makeStyles } from "@material-ui/core/styles";

export const BtnStyle = () => {
  const useStyles = makeStyles({
    btnStyle: {
      outline: "none",
      border: "none",
      fontSize: "22px",
      color: "#6161ea",
      cursor: "pointer",
      fontFamily: "none",
      fontStyle: "italic",
    },
    containerStyle: {
      position: "absolute",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "#f2f1f1",
      width: "-webkit-fill-available",
      left: "0",
      marginTop: "-22px",
      height: "43px",
    },
  });
  const styles = useStyles();
  return styles;
};
